module.exports = __webpack_public_path__ + "img/logo_power.fe29db1d.svg";